import { Injectable } from '@angular/core';
import { B2BUnit, DefaultRoutePageMetaResolver, TranslationService } from '@spartacus/core';
import { CurrentUnitService } from '@spartacus/organization/administration/components';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UigUnitRoutePageMetaResolver extends DefaultRoutePageMetaResolver {
  constructor(
    translation: TranslationService,
    protected currentItemService: CurrentUnitService
  ) {
    super(translation);
  }

  protected getParams(): Observable<B2BUnit> {
    return this.currentItemService.item$;
  }
}